<span [class]="class">{{(countUpValue || 0) | number: format:'en-US'}}</span>